import {observer} from "mobx-react";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR} from "../../../../../../components/fonts/font-props";
import {FormField} from "../../../../../../components/form-field/form-field";
import Icon from "../../../../../../components/icons/icon/icon";
import {Textarea} from "../../../../../../components/inputs/textarea/textarea";
import {LABEL_POSITIONS, Toggle} from "../../../../../../components/inputs/toggle/toggle";
import ValidateItemRowStore from "./validate-item-row-store";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import rmsMixpanelStore from "../../../../../../stores/rms-mixpanel-store";
import rmaPageMainStore from "../../../stores/rma-page-main-store";

interface IValidateItemRowEditProps {
    store: ValidateItemRowStore;
}

const ValidateItemRowEdit : React.FC<IValidateItemRowEditProps> = observer(({store})=> {
    const { getTranslation } = useDashboardTranslation();
    const itemValidationPopupScope = 'dashboard-item-validation-popup';

    const translatedLabel = getTranslation(store.label, itemValidationPopupScope);

    const onToggleChange = () => {
        rmsMixpanelStore.trackEvent('d&_original_item_valitadion_toggle', {"type": translatedLabel, RMAID: rmaPageMainStore.getRmaPageStore()?.rmaId });
        store.setChecked(!store.isChecked);
    }

    return (
        <div className={'validate-item-row'}>
            <div className={'validate-item-row-text'}>
                <div className={'validate-item-icon'}>
                    <Icon Component={store.icon} color={'var(--color-accent-1)'}/>
                </div>
                <div className={'validate-item-label'}>
                    <FontBody2 color={FONT_COLOR.PRIMARY2}>{translatedLabel}</FontBody2>
                </div>
                <div className={'validate-item-bool'}>
                    <Toggle label={''} labelPosition={LABEL_POSITIONS.LEFT} checked={store.isChecked} onChange={onToggleChange} />
                </div>
            </div>
            { !store.isChecked &&
                <>
                    <FormField label={getTranslation('WHY_NOT', itemValidationPopupScope)} required>
                        <Textarea placeholder={getTranslation('TEXT', itemValidationPopupScope)} onChange={store.setComment} value={store.comment} />
                    </FormField>
                </>
            }
        </div>
    )
});

export default ValidateItemRowEdit;